<template>
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
    <path d="M1.97369 17.4671V17.4734C1.97369 17.9574 2.36369 18.3497 2.84606 18.3545H12.9434C13.1757 18.3522 13.3977 18.2582 13.5611 18.0931C13.7245 17.9279 13.816 17.7049 13.8158 17.4726V5.62341H1.97369V17.4671ZM3.1579 6.8092H12.6316V17.171H3.1579V6.8092Z" :fill="color"/>
    <path d="M4.63815 7.99341H5.82236V15.3947H4.63815V7.99341Z" :fill="color"/>
    <path d="M7.30264 7.99341H8.48685V15.3947H7.30264V7.99341Z" :fill="color"/>
    <path d="M9.9671 7.99341H11.1513V15.3947H9.9671V7.99341Z" :fill="color"/>
    <path d="M10.5592 3.25664V1.48032C10.5592 0.982163 10.2079 0.592163 9.75949 0.592163H6.02922C5.5808 0.592163 5.22949 0.982163 5.22949 1.48032V3.25664H0.788696V4.44085H14.9992V3.25664H10.5592ZM6.41449 1.77637H9.37501V3.25664H6.41449V1.77637Z" :fill="color"/>
    </g>
    </svg>
</template>

<script>
export default {
  name: 'TrashIcon',
  props: ['color']
}
</script>
